import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Body, MenuPath, Note, SectionDivider } from '../ui';

// ── Page ────────────────────────────────────────────────────────────────────

const PreferencesDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      {/* -- Intro -- */}
      <h2
        id="preferences"
        className="font-display text-[24px] font-extrabold text-content-primary mb-[16px] tracking-[-0.4px]"
      >
        {t('docs.preferences.title')}
      </h2>
      <Body>
        <Trans
          i18nKey="docs.preferences.intro"
          components={{ strong: <strong />, code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <SectionDivider />

      {/* -- Global -- */}
      <h2 id="global" className="font-display text-[24px] font-extrabold text-content-primary mb-[16px] tracking-[-0.4px]">
        {t('docs.preferences.globalTitle')}
      </h2>
      <Body>{t('docs.preferences.globalBody')}</Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.opacityTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.preferences.opacityBody"
          components={{ strong: <strong />, code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.showHoverLabelTitle')}
      </h3>
      <Body>{t('docs.preferences.showHoverLabelBody')}</Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.smoothMeshTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.preferences.smoothMeshBody"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.disableOnNewSceneTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.preferences.disableOnNewSceneBody"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <SectionDivider />

      {/* -- Editor -- */}
      <h2
        id="editor"
        className="font-display text-[24px] font-extrabold text-content-primary mb-[16px] tracking-[-0.4px]"
      >
        {t('docs.preferences.editorTitle')}
      </h2>
      <Body>
        <Trans
          i18nKey="docs.preferences.editorBody"
          components={{ strong: <strong /> }}
        />
      </Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.mainTouchSetTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.preferences.mainTouchSetBody"
          components={{ strong: <strong />, code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>
      <Note label={t('docs.preferences.noteLabel')}>
        {t('docs.preferences.mainTouchSetNote')}
      </Note>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.mirrorTokensTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.preferences.mirrorTokensBody1"
          components={{ strong: <strong />, code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.preferences.mirrorTokensBody2"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>
      <Note label={t('docs.preferences.noteLabel')}>
        <Trans
          i18nKey="docs.preferences.mirrorTokensNote"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Note>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.previewAfterApplyTitle')}
      </h3>
      <Body>{t('docs.preferences.previewAfterApplyBody')}</Body>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.preferences.previewControlNamesTitle')}
      </h3>
      <Body>{t('docs.preferences.previewControlNamesBody')}</Body>
    </article>
  );
};

export default PreferencesDoc;
